import SampleSelectionController from './SampleSelectionController';
import Select from 'react-select';
// import Loader from 'utils/Loader';
// import { greenColor, redColor, whiteColor } from 'utils/constants';
// import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
// import { Box, Card, Grid, TextField, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '../../../node_modules/@mui/material/index';

import {
  Box,
  Card,
  Grid,
  TextField,
  Typography,
  // IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";

// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove';
import { Close } from '../../../node_modules/@mui/icons-material/index';

// import ReactSelect from 'react-select';
// import { DataGrid } from '@mui/x-data-grid';

function SampleSelection() {
  const {
    barcodeData,
    sampleTypes,
    sampleCategory,
    setSampleCategory,
    // selectedSampleType,
    // setSelectedSampleType,
    setBarcodeSampleType,
    customerOptions,
    selectedCustomer,
    setSelectedCustomer,
    handleInputChange,
    setBarcodeSampleQuantity,
    submitSampleRequest,
    openRemarkDialog,
    setOpenRemarkDialog,
    remark,
    setRemark,
    remarkError,
    submitRemark
  } = SampleSelectionController();

  const shouldRenderTable = barcodeData && barcodeData.length > 0;

  // const columns = (sampleTypes, setBarcodeSampleType, setBarcodeSampleQuantity) => [
  //   {
  //     field: "materialDesc",
  //     headerName: "Description",
  //     flex: 1,
  //     minWidth: 180,
  //     renderCell: (params) => (
  //       <Typography>{params.row.materialDesc}</Typography>
  //     )
  //   },

  //   {
  //     field: "sampleType",
  //     headerName: "Sample Type",
  //     flex: 1,
  //     minWidth: 220,
  //     renderCell: (params) => {
  //       const idx = params.api.getRowIndex(params.row.id);
  //       return (
  //         <Box sx={{ width: "100%" }}>
  //           <ReactSelect
  //             value={params.row.sampleType || null}
  //             options={sampleTypes}
  //             onChange={(opt) => setBarcodeSampleType(idx, opt)}
  //             placeholder="Select Type"
  //             menuPortalTarget={document.body}
  //             styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
  //           />
  //           {params.row.errors?.sampleType && (
  //             <Typography sx={{ color: "red", fontSize: 12 }}>
  //               {params.row.errors.sampleType}
  //             </Typography>
  //           )}
  //         </Box>
  //       );
  //     }
  //   },

  //   {
  //     field: "sampleQuantity",
  //     headerName: "Quantity",
  //     flex: 1,
  //     minWidth: 200,
  //     renderCell: (params) => {
  //       const idx = params.api.getRowIndex(params.row.id);
  //       const item = params.row;

  //       return (
  //         <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
  //           <IconButton
  //             size="small"
  //             onClick={() => {
  //               const next = Math.max(0, (item.sampleQuantity || 0) - 1);
  //               setBarcodeSampleQuantity(idx, next);
  //             }}
  //           >
  //             <RemoveIcon fontSize="small" />
  //           </IconButton>

  //           <TextField
  //             type="text"
  //             size="small"
  //             sx={{ width: 60 }}
  //             value={item.sampleQuantity ?? 0}
  //             onChange={(e) => {
  //               const raw = e.target.value;
  //               const qty = raw === "" ? 0 : Math.max(0, parseInt(raw, 10) || 0);
  //               setBarcodeSampleQuantity(idx, qty);
  //             }}
  //             error={!!item.errors?.sampleQuantity}
  //             helperText={item.errors?.sampleQuantity || ""}
  //           />

  //           <IconButton
  //             size="small"
  //             onClick={() => {
  //               const next = (item.sampleQuantity || 0) + 1;
  //               setBarcodeSampleQuantity(idx, next);
  //             }}
  //           >
  //             <AddIcon fontSize="small" />
  //           </IconButton>
  //         </Box>
  //       );
  //     }
  //   }
  // ];

  return (
    <div className="bg" style={{ display: 'block' }}>
      {/* {isData ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Data Loading...</span>
        </div>
      ) : null} */}
      <div className="cutrange">
        <span className="font20">SAMPLE SELECTION</span>
      </div>

      {/* Radio Buttons */}
      <Box sx={{ mt: 2 }}>
        <Grid container spacing={4} alignItems="center">
          <Grid item container xs={12} sm={6}>
            <Grid item xs={12} sm={2} sx={{ display: 'flex' }} alignItems="center">
              <Typography variant="h5" sx={{ color: "white", mb: 1 }}>
                Party Name:
              </Typography>
            </Grid>
            <Grid item xs={12} sm={10}>
              <Box sx={{ width: "100%" }}>
                <Select
                  sx={{ width: '100%' }}
                  options={customerOptions}
                  value={selectedCustomer}
                  onChange={(value) => setSelectedCustomer(value)}
                  onInputChange={handleInputChange}
                  placeholder="Select Party"
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid item container spacing={1} xs={12} sm={6} alignItems="center">
            <Grid item alignItems="center">
              <Typography variant="h5" sx={{ color: "white", mb: 1 }}>
                Sample Category:
              </Typography>
            </Grid>
            <Grid item>
              <Box sx={{ display: 'flex', gap: 4, marginTop: '-5px' }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="sampleCategory"
                    value="Retail"
                    checked={sampleCategory === "Retail"}
                    onChange={() => setSampleCategory("Retail")}
                    style={{ width: 18, height: 18, marginRight: 8 }}
                  />
                  Retail
                </label>

                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="sampleCategory"
                    value="Replenishment"
                    checked={sampleCategory === "Replenishment"}
                    onChange={() => setSampleCategory("Replenishment")}
                    style={{ width: 18, height: 18, marginRight: 8 }}
                  />
                  Replenishment
                </label>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>

      <div className="vertical-center">

        <Box sx={{ width: "100%", mt: 2, mb: 2 }}>

        </Box>

        {shouldRenderTable ? (
          <Box sx={{ width: "100%", mb: 2 }}>
            <Grid container spacing={2}>
              {barcodeData.map((item, idx) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={item.id ?? idx}>
                  <Card p={1} sx={{ margin: 1, padding: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Typography variant="h5" sx={{ color: 'grey', mr: 1 }}>
                        Description-
                      </Typography>
                      <Typography variant="h5" sx={{ color: 'black' }}>
                        {item.materialDesc || "-"}
                      </Typography>
                    </Box>
                    <Box sx={{ minWidth: 200, mt: 1 }}>
                      <Typography variant="caption" sx={{ color: 'black', display: 'block', mb: 0.5 }}>
                        Sample Type
                      </Typography>
                      <Select
                        value={item.sampleType ?? null}
                        onChange={(opt) => setBarcodeSampleType(idx, opt)}
                        options={sampleTypes}
                        placeholder="Sample type"
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      />

                      <Typography sx={{ color: "red", fontSize: 12, minHeight: "18px" }}>
                        {item.errors?.sampleType || " "}
                      </Typography>
                    </Box>
                    {/* 
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="caption" sx={{ color: 'black', display: 'block', mb: 0.5 }}>Quantity</Typography>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IconButton
                          size="small"
                          onClick={() => {
                            const cur = Number(item.sampleQuantity || 0);
                            const next = Math.max(0, cur - 1);
                            setBarcodeSampleQuantity(idx, next);
                          }}
                          aria-label="decrease"
                        >
                          <RemoveIcon fontSize="small" sx={{ color: "black", mt: "-20px" }} />
                        </IconButton>

                        <TextField
                          type="text"
                          value={Number(item.sampleQuantity || 0)}
                          onChange={(e) => {
                            const raw = e.target.value;
                            const qty = raw === '' ? 0 : Math.max(0, parseInt(raw, 10) || 0);
                            setBarcodeSampleQuantity(idx, qty);
                          }}
                          inputProps={{ min: 0, style: { textAlign: 'center' } }}
                          variant="outlined"
                          size="small"
                          sx={{ width: "80%" }}
                          error={Boolean(item.errors?.sampleQuantity)}
                          helperText={item.errors?.sampleQuantity || " "}
                          FormHelperTextProps={{
                            sx: { color: "red", minHeight: "18px" }
                          }}
                        />

                        <IconButton
                          size="small"
                          onClick={() => {
                            const cur = Number(item.sampleQuantity || 0);
                            const next = cur + 1;
                            setBarcodeSampleQuantity(idx, next);
                          }}
                          aria-label="increase"
                        >
                          <AddIcon fontSize="small" sx={{ color: "black", mt: "-21px" }} />
                        </IconButton>
                      </Box>

                      {item.errors?.sampleQuantity && (
                        <Typography sx={{ color: "red", fontSize: 12 }}>
                          {item.errors.sampleQuantity}
                        </Typography>
                      )} 
                    </Box> */}
                    <Box>
                      {/* QUANTITY INPUT */}
                      <Box sx={{ width: "100%" }}>
                        <Typography
                          variant="caption"
                          sx={{ color: "black", display: "block", mb: 0.5 }}
                        >
                          Quantity
                        </Typography>

                        <TextField
                          placeholder="Enter Quantity"
                          type="text"
                          variant="outlined"
                          // size="small"
                          fullWidth
                          value={item.sampleQuantity ?? ""}
                          onChange={(e) => {
                            const value = e.target.value;

                            // Allow only digits
                            if (/^\d*$/.test(value)) {
                              const qty = value === "" ? "" : Number(value);
                              setBarcodeSampleQuantity(idx, qty);
                            }
                          }}
                          inputProps={{
                            inputMode: "numeric",
                            min: 0,
                          }}
                          error={Boolean(item.errors?.sampleQuantity)}
                          helperText={item.errors?.sampleQuantity || " "}
                          FormHelperTextProps={{
                            sx: { color: "red", minHeight: "18px" },
                          }}
                        />
                      </Box>

                    </Box>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        ) : null}
      </div>

      <div className="footer-button">
        <button style={{ marginRight: '15px' }}>
          {'Cancel'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={submitSampleRequest}>
          {'Proceed'}
        </button>
      </div>

      {shouldRenderTable && (
        <Box sx={{ height: 600, width: "100%", mt: 3 }}>
          {/* <DataGrid
            rows={barcodeData.map((item, idx) => ({ ...item, id: idx }))}
            columns={columns(sampleTypes, setBarcodeSampleType, setBarcodeSampleQuantity)}
            pageSize={10}
            disableRowSelectionOnClick
            getRowId={(row) => row.id}
            // sx={{
            //   bgcolor: "white",
            //   borderRadius: 1,
            //   "& .MuiDataGrid-cell": {
            //     alignItems: "flex-start",
            //   }
            // }}
          /> */}
        </Box>
      )}


      <Dialog
        open={openRemarkDialog}
        onClose={() => setOpenRemarkDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            width: '100%',
            fontWeight: 'bold',
            fontSize: '1.5rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 0,
          }}
        >
          Remarks
          <Close onClick={() => setOpenRemarkDialog(false)} />
        </DialogTitle>

        <DialogContent dividers>
          <textarea
            type="text"
            name="remark"
            value={remark}
            className="form-control inp_text"
            id="remark"
            rows={7}
            cols={50}
            maxLength={1000}
            onChange={(e) => setRemark(e.target.value)}
            placeholder="Write Remark Here..."
            autoFocus
          />
          <div style={{ textAlign: 'right', fontSize: '12px', color: '#000000' }}>
            {remark.length}/1000
          </div>

          {remarkError && (
            <Typography
              variant="body2"
              sx={{ color: "red", mt: 1, fontSize: "0.9rem" }}
            >
              {remarkError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'end', px: 3, py: 2 }}>
          {/* <Button
            variant="outlined"
            sx={{
              color: 'white !important',
              backgroundColor: 'black',
              borderColor: 'black !important',
              '&:hover': { color: 'white', backgroundColor: 'black !important', borderColor: 'black !important' },
            }}
            onClick={() => setOpenRemarkDialog(false)}
          >
            Cancel
          </Button> */}
          <Button
            variant="contained"
            sx={{
              fontWeight: 'bold',
            }}
            onClick={() => submitRemark()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SampleSelection;
